import { gql } from '../../__generated__'

export const RECORD_USER_ACTIVITY = gql(/* GraphQL */ `
  mutation RecordUserActivity {
    recordUserActivity
  }
`)
